import React from "react";
import "./AdminDashboardHome.css";

// One row of "Recent Activity" (Admin Command Centre redesign). Built ONLY
// from real, timestamped task events (created / completed) -- there is no
// audit-log endpoint anywhere in this app, so this intentionally does not
// claim to cover user/permission/form/inventory events.
export default function ActivityRow({ icon, tone = "info", text, timestamp }) {
  return (
    <div className="adh-activity-row">
      <span className={`adh-activity-icon adh-activity-icon--${tone}`}>
        <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
      </span>
      <span className="adh-activity-text">{text}</span>
      <span className="adh-activity-time">{timestamp}</span>
    </div>
  );
}
